export default "assets/images/icons/paiement-9169b345.svg";